import { makeStyles } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { dataService } from "../../../Services/data/data.service";
import DividerImage from "../../../Images/line2.png";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { InlineWidget } from "react-calendly";

// Styling
import "react-toastify/dist/ReactToastify.css";
import "./Assets/styles/bookdemo-styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

// JS
import "https://cdnjs.cloudflare.com/ajax/libs/gsap/latest/TweenLite.min.js";
// import "https://assets.calendly.com/assets/external/widget.js";

// Images
import img_logo from "./Assets/images/logo.png";

function BookDemoPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);

  // useEffect(() => {
  //     // Load Calendly script dynamically
  //     const script = document.createElement("script");
  //     script.src = "https://assets.calendly.com/assets/external/widget.js";
  //     script.async = true;
  //     document.body.appendChild(script);

  //     return () => {
  //         // Cleanup script if needed
  //         document.body.removeChild(script);
  //     };
  // }, [])

  return (
    <div className="bookdemopage">
      <header className="header">
        <div className="container">
          <div className={classes.navbar_start}>
            <div className="logo">
              <Link to="/">
                <img src={img_logo} alt="" />
              </Link>
            </div>
            <Link to="/pricing" className={classes.navLink}>
              Pricing
            </Link>
          </div>
          <Link className="btn_design" to="/login">
            Login
          </Link>
        </div>
      </header>
      <section className="banner">
        <div className="container">
          <div className="row">
            <div style={{ minWidth: "320px", height: "700px" }}>
              <InlineWidget data-auto-height="true" url="https://calendly.com/jurgen_flagstone/book-a-taplr-demo-unlock-efficiency-with-task-mining" />
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="container">
          <p>
            © 2025 <Link to="/"> Taplr </Link>. All rights reserved. Taplr is a product by Flagstone BV, Stedestraat 51, 8530 Harelbeke - Belgium. <Link to="/privacypolicy">Privacy Policy</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#231F20",
    paddingTop: "65px",

    [theme.breakpoints.down("lg")]: {
      paddingTop: "20px",
    },
  },

  navbar_start: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "48px",
    padding: "0 15px",
    boxSizing: "border-box",
    height: "100%",
    [theme.breakpoints.down("lg")]: {
      padding: "0 10px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 5px",
    },
  },

  navLink: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "500",
    textDecoration: "none",
    padding: "0 15px",
    boxSizing: "border-box",
    "&:hover": {
      color: "#fff",
      textDecoration: "underline",
    },
  },

  container: {
    maxWidth: "1560px",

    margin: "0 auto",
    padding: "0 15px",
    boxSizing: "border-box",
  },

  row: {
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },

  col5: {
    flex: "0 0 41.666%",
    maxWidth: "41.666%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col6: {
    flex: "0 0 50%",
    maxWidth: "50%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col7: {
    flex: "0 0 58.333%",
    maxWidth: "58.333%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  logo: {
    // image inside
    "& img": {
      [theme.breakpoints.down("md")]: {
        width: "130px",
      },

      [theme.breakpoints.down("sm")]: {
        width: "118px",
      },
    },
  },

  banner: {
    padding: "30px 0 110px",
    backgroundColor: "#231F20",
    boxSizing: "border-box",

    [theme.breakpoints.down("lg")]: {
      padding: "30px 0 70px",
    },

    [theme.breakpoints.down("md")]: {
      padding: "0px 0 70px",
      marginTop: "-1px",
    },
  },
}));
export default BookDemoPage;
